/**
 * @fileoverview 针对映射键值对的行操作
 * */

/**
 * 根据输入框变化调整行数
 *
 * @param row 行对象
 * @param numName 行数参数名
 * @param valueName 行值参数名
 * @returns 返回处理后的行对象
 */
export function handleRowChange (row, numName, valueName) {
  // num为row的数量参数名，value为row的value值参数名
  const newValue = []
  const currentValue = row[valueName] || []
  //  将行数转化为number类型
  let numValue = parseInt(row[numName], 10)
  console.log('numValue', numValue)
  if (numValue > 101) {
    numValue = 100
  }
  row[numName] = numValue
  // 输入框输入的行数小于1,确保起码有一行
  if (isNaN(numValue) || numValue < 1) {
    row[numName] = 1
    return
  }
  // 调整行数
  for (let i = 0; i < numValue; i++) {
    // 新的行数小于当前的行数，则从尾部删除
    if (i < currentValue.length) {
      newValue.push(currentValue[i])
    } else {
      // 新的行数大于当前的行数，则从尾部添加
      newValue.push({ index: i + 1, key: '', value: '' })
    }
  }
  row[valueName] = newValue
  return row
}

// 新增一行(值映射)
export function handleAddRow (row, numName, valueName, index) {
  row[valueName].splice(index + 1, 0, { index: index + 1, key: '', value: '' })
  row[numName] += 1
  return row
}

// 删除一行(值映射)
export function handleDeleteRow (row, numName, valueName, index) {
  row[valueName].splice(index, 1)
  row[numName] -= 1
  return row
}

// 新增一行(bit映射)
export function handleAddRowBit (row, numName, valueName, index) {
  row[valueName].splice(index + 1, 0, { index: index + 1, key: '', value: '' })
  return row
}

// 删除一行(bit映射)
export function handleDeleteRowBit (row, numName, valueName, index) {
  row[valueName].splice(index, 1)
  return row
}
